module.exports = __webpack_public_path__ + "media/images/element/19-24121a96aefb84206f59cc4dc1b36c47.svg";